import colors from '@/components/kit/theme'

export default (ctx, inject) => {
  inject('chartLegendColor', (type, data) => {
    if (!type || type === '') {
      return null
    }
    switch (type) {
      case 'grid':
        return colors.knownColor('graph-blue')
      case 'solar':
        return colors.knownColor('graph-green')
      case 'solar-export':
      case 'forecast-solar-export':
        return [
          colors.knownColorWithOpacity('graph-green', 30),
          colors.knownColor('graph-green')
        ]
      case 'currency':
        return colors.knownColor('graph-orange')
      case 'currency-night':
        return colors.knownColor('graph-pink')
      case 'currency-export':
        return [
          colors.knownColorWithOpacity('graph-orange', 15),
          colors.knownColor('graph-orange')
        ]
      case 'currency-solar':
        return [
          colors.knownColorWithOpacity('graph-orange', 30),
          colors.knownColor('graph-orange')
        ]
      case 'current':
        return [
          colors.knownColorWithOpacity('graph-red', 30),
          colors.knownColor('graph-red')
        ]
      case 'forecast':
        return colors.knownColor('blue-400')
      case 'forecast-currency':
        return colors.knownColor('graph-orange')
      case 'forecast-solar':
        return colors.knownColor('graph-green')
      case 'forecasted':
        return colors.knownColor('blue-300')
      case 'forecasted-currency':
        return colors.knownColor('orange-200')
      case 'forecasted-solar':
        return colors.knownColor('green-200')
      case 'expected':
        return ['transparent', colors.knownColor('blue-800')]
      case 'expected-currency':
        return ['transparent', colors.knownColor('orange-900')]
      case 'expected-solar':
        return ['transparent', colors.knownColor('green-900')]
      case 'empty':
        return colors.knownColor('grey-midlight')
      case 'comparison':
        return ['#00D4B5', '#FFD888', '#FDABA5']
      case 'appliances': {
        const appliances = data
        const arrColors = []

        appliances.forEach((appliance) => {
          arrColors.push(
            colors.knownColor(ctx.app.$applianceType(appliance).color)
          )
        })
        return arrColors
      }
      default:
    }
  })
  inject('chartMaxTicksLimit', (type) => {
    if (!type || type === '') {
      return null
    }
    switch (type) {
      case 'current':
        return { amount: 3, offset: 30 }
      case 'day':
        return { amount: 4, offset: 15 }
      case 'week':
        return { amount: 6, offset: 18 }
      case 'month':
        return { amount: 4, offset: 20 }
      case 'year':
        return { amount: 10, offset: 12 }
      default:
    }
  })
  inject('chartDatasets', (type, chart, data) => {
    if (!type || type === '' || !chart || chart === '') {
      return null
    }
    let defaultOptions = null
    switch (chart) {
      case 'bar':
        defaultOptions = {
          type: 'bar',
          borderWidth: 1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          pointHoverRadius: 6,
          pointHoverBackgroundColor: 'white',
          pointHoverBorderWidth: 2,
          stack: 'bar-chart',
          barPercentage: 1,
          categoryPercentage: 0.8,
          barThickness: 'flex',
          legend: type
        }
        break
      case 'line':
        defaultOptions = {
          type: 'line',
          borderWidth: 2,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          pointHoverRadius: 6,
          pointHoverBackgroundColor: 'white',
          pointHoverBorderWidth: 2,
          legend: type
        }
        break
      case 'doughnut':
        defaultOptions = {
          borderWidth: 2,
          hoverBorderWidth: 2,
          borderColor: 'white',
          hoverBorderColor: 'white'
        }
        break
      default:
    }
    switch (type) {
      case 'grid':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('gridConsumption'),
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'solar':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('solarConsumption'),
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type),
          borderSkipped: {
            left: false,
            right: false,
            top: true,
            bottom: false
          }
        }
      case 'solar-export':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('solarExport'),
          backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1]
        }
      case 'currency':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('currencyDay'),
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'currency-night':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('currencyNight'),
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type),
          borderSkipped: { left: false, right: false, top: true, bottom: false }
        }
      case 'currency-export':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('currencyExport'),
          backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1]
        }
      case 'currency-solar':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('currencySolar'),
          backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4
        }
      case 'current':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('currentPowerDemand'),
          backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 1,
          cubicInterpolationMode: 'monotone'
        }
      case 'expected':
      case 'expected-currency':
      case 'expected-solar':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('expectedConsumption'),
          backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4,
          borderDash: [3, 3],
          cubicInterpolationMode: 'monotone'
        }
      case 'forecast':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('grid_current'),
          /* backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4, */
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'forecast-currency':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('currency_current'),
          /* backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4, */
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'forecast-solar':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('solar_current'),
          /* backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4, */
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'forecast-solar-export':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('selfConsumption'),
          backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1]
        }
      case 'forecasted':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('grid_forecasted'),
          /* backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4,
          borderDash: [3, 3], */
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'forecasted-currency':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('currency_forecasted'),
          /* backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4,
          borderDash: [3, 3], */
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'forecasted-solar':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('solar_forecasted'),
          /* backgroundColor: ctx.app.$chartLegendColor(type)[0],
          hoverBackgroundColor: ctx.app.$chartLegendColor(type)[0],
          borderColor: ctx.app.$chartLegendColor(type)[1],
          pointHoverBorderColor: ctx.app.$chartLegendColor(type)[1],
          lineTension: 0.4,
          borderDash: [3, 3], */
          backgroundColor: ctx.app.$chartLegendColor(type),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type),
          pointHoverBorderColor: ctx.app.$chartLegendColor(type),
          borderColor: ctx.app.$chartLegendColor(type)
        }
      case 'appliances':
        return {
          ...defaultOptions,
          label: ctx.app.i18n.t('powerDemand'),
          backgroundColor: ctx.app.$chartLegendColor(type, data),
          hoverBackgroundColor: ctx.app.$chartLegendColor(type, data)
        }
      default:
    }
  })
  inject('applianceType', (typeId) => {
    const types = {
      5: {
        color: 'appliance-washingmachine',
        icon: 'app-washingmachine',
        name: 'washingMachine',
        logs: true
      },
      9: {
        color: 'appliance-kettle',
        icon: 'app-ketle',
        name: 'kettle',
        logs: true
      },
      20: {
        color: 'appliance-microwave',
        icon: 'app-microwave',
        name: 'microwave',
        logs: true
      },
      24: {
        color: 'appliance-fridge',
        icon: 'app-fridge',
        name: 'fridge',
        logs: false
      },
      /* 28: {
        color: 'appliance-toaster',
        icon: 'app-taoster',
        name: 'toaster',
        logs: true
      }, */
      34: {
        color: 'appliance-dishwasher',
        icon: 'app-dishwasher',
        name: 'dishwasher',
        logs: true
      },
      35: {
        color: 'appliance-oven',
        icon: 'app-oven',
        name: 'oven',
        logs: true
      },
      /* 43: {
        color: 'appliance-tumbledryer',
        icon: 'app-tumbledryer',
        name: 'tumbleDryer',
        logs: true
      }, */
      100: {
        color: 'appliance-heatpump',
        icon: 'app-heatpump',
        name: 'heatPump',
        logs: true
      },
      993: {
        color: 'appliance-others',
        icon: 'app-others',
        name: 'others',
        logs: false
      },
      998: {
        color: 'appliance-alwayson',
        icon: 'app-alwayson',
        name: 'alwaysOn',
        logs: false
      },
      9001: {
        color: null,
        icon: null,
        name: 'generalConsumption',
        logs: false
      }
    }

    if (!typeId || typeId === '' || typeId === 'undefined' || !types[typeId]) {
      typeId = 993
    }

    const type = types[typeId]
    const result = {
      ...type,
      color: type.color
    }
    return result
  })

  inject('alertStatus', (status) => {
    if (!status || status === '') {
      return null
    }
    switch (status) {
      case 'on':
        return {
          color: colors.knownColor('red-mid'),
          icon: { name: 'alert-on', fill: 'red-light' }
        }
      case 'off':
        return {
          color: colors.knownColor('grey-dark'),
          icon: { name: 'alert-on', fill: 'grey-light' }
        }
      default:
    }
  })
  inject('statusStyle', (style, isForecastAndSolar) => {
    if (!style || style === '') {
      return null
    }
    switch (style) {
      case 'positive':
        return {
          name: 'positive',
          color: 'green-mid',
          colors: ['green-light', 'green-mid'],
          icon: isForecastAndSolar ? 'triangle-up' : 'triangle-down',
          size: 'small'
        }
      case 'negative':
        return {
          name: 'negative',
          color: 'red-mid',
          colors: ['red-light', 'red-mid'],
          icon: isForecastAndSolar ? 'triangle-down' : 'triangle-up',
          size: 'small'
        }
      case 'neutral':
        return {
          name: 'neutral',
          color: 'orange-mid',
          colors: ['orange-light', 'orange-mid'],
          icon: 'triangle-forward',
          size: 'small'
        }
      case 'live':
        return {
          name: 'live',
          colors: 'white',
          icon: { name: 'status-circle', fill: 'red-mid' },
          size: 'medium'
        }
      case 'empty':
        return {
          name: 'empty',
          colors: 'white',
          size: 'medium'
        }
      default:
    }
  })

  inject('chartStyleByFormat', (format, multipleColours) => {
    if (format === 'energy') {
      const colorLegend = [ctx.$chartLegendColor('grid')]
      const chartdatasets = [ctx.$chartDatasets('grid', 'bar')]

      if (multipleColours) {
        colorLegend.splice(1, 0, ctx.$chartLegendColor('solar'))
        chartdatasets.push(ctx.$chartDatasets('solar', 'bar'))
      }

      return {
        colorLegend,
        subtitle: ctx.app.i18n.t('gridConsumption'),
        chartdatasets
      }
    }

    const colorLegend = [ctx.$chartLegendColor('currency')]
    const chartdatasets = [ctx.$chartDatasets('currency', 'bar')]

    if (multipleColours) {
      colorLegend.splice(1, 0, ctx.$chartLegendColor('currency-night'))
      chartdatasets.push(ctx.$chartDatasets('currency-night', 'bar'))
    }
    return {
      colorLegend,
      subtitle: ctx.app.i18n.t('energyCost'),
      chartdatasets
    }
  })

  inject('panelPlaceholder', (type) => {
    if (!type) {
      return null
    }
    let energyPlaceholder
    if (
      ['energysetup', 'tariffsetup', 'budgetsetup'].some((term) =>
        type.includes(term)
      )
    ) {
      energyPlaceholder = {
        icon: {
          name: 'energysetup',
          fill: 'grey-dark',
          size: '32px'
        },
        subtitle: ctx.app.i18n.t('setNewEnergyTariffBudgetText')
      }
    }
    switch (type) {
      case 'energysetup':
        return {
          ...energyPlaceholder,
          title: ctx.app.i18n.t('setNewEnergyTariffBudgetTitle'),
          action: {
            text: ctx.app.i18n.t('setupNow'),
            route: 'energy-settings'
          },
          formats: ['currency', 'energy']
        }
      case 'tariffsetup':
        return {
          ...energyPlaceholder,
          title: ctx.app.i18n.t('setNewEnergyTariffTitle'),
          action: {
            text: ctx.app.i18n.t('setupNow'),
            route: 'energy-settings-tariff'
          },
          formats: ['currency']
        }
      case 'budgetsetup':
        return {
          ...energyPlaceholder,
          title: ctx.app.i18n.t('setNewEnergyBudgetTitle'),
          action: {
            text: ctx.app.i18n.t('setupNow'),
            route: 'energy-settings-budget'
          },
          formats: ['energy']
        }
      case 'solarPvOptimisation':
        return {
          ...energyPlaceholder,
          title: ctx.app.i18n.t('setNewEnergyBudgetTitle'),
          action: {
            text: ctx.app.i18n.t('setupNow'),
            route: 'energy-settings-pv-optimasation'
          },
          formats: ['energy']
        }
    }
  })

  inject('panelButton', (type) => {
    if (!type) {
      return null
    }
    switch (type) {
      case 'forecast':
        return [
          {
            text: ctx.app.i18n.t('showPreviousMonth')
          },
          {
            text: ctx.app.i18n.t('showLess'),
            icon: {
              name: 'arrow-up',
              fill: 'blue-400',
              size: '16px'
            }
          }
        ]
      default:
    }
  })
  inject('radioButtonGroup', (type) => {
    if (!type) return null
    switch (type) {
      case 'boolean':
        return [
          { id: true, text: ctx.app.i18n.t('yes') },
          { id: false, text: ctx.app.i18n.t('no') }
        ]
      case 'oil':
        return [
          { id: 1, text: ctx.app.i18n.t('litres'), _based: 'consumption' },
          {
            id: 2,
            text: ctx.app.i18n.t('consumptionBased'),
            _based: 'kwh'
          }
        ]
      case 'gas':
        return [
          { id: 1, text: ctx.app.i18n.t('cubicMeter'), _based: 'consumption' },
          {
            id: 2,
            text: ctx.app.i18n.t('consumptionBased'),
            _based: 'kwh'
          }
        ]
      case 'usage-based':
        return [
          { id: 1, text: ctx.app.i18n.t('costBased'), _based: 'cost' },
          {
            id: 2,
            text: ctx.app.i18n.t('consumptionBased'),
            _based: 'kwh'
          }
        ]
      case 'fixed-costs':
        return [
          {
            id: 1,
            text: ctx.app.i18n.t('daily'),
            value: 1,
            unit: ctx.app.i18n.t('day').toLowerCase()
          },
          {
            id: 2,
            text: ctx.app.i18n.t('monthly'),
            value: 3,
            unit: ctx.app.i18n.t('month').toLowerCase()
          },
          {
            id: 3,
            text: ctx.app.i18n.t('yearly'),
            value: 4,
            unit: ctx.app.i18n.t('year').toLowerCase()
          }
        ]
      case 'end-date-options':
        return [
          {
            id: 1,
            text: ctx.app.i18n.tc('years', 1)
          },
          {
            id: 2,
            text: ctx.app.i18n.tc('years', 2)
          },
          {
            id: 3,
            text: ctx.app.i18n.t('custom')
          }
        ]
      default:
    }
  })
  inject('radioButtonCardGroup', (type) => {
    if (!type) return null
    switch (type) {
      case 'boolean':
        return [
          {
            id: ctx.app.$radioButtonGroup(type)[0].id,
            text: ctx.app.$radioButtonGroup(type)[0].text,
            icon: 'elebill'
          },
          {
            id: ctx.app.$radioButtonGroup(type)[1].id,
            text: ctx.app.$radioButtonGroup(type)[1].text,
            icon: 'unknown'
          }
        ]
      case 'gas-oil':
        return [
          {
            id: 1,
            text: ctx.app.i18n.t('gas'),
            icon: 'gas',
            _type: 'gas'
          },
          {
            id: 2,
            text: ctx.app.i18n.t('oil'),
            icon: 'oil',
            _type: 'oil'
          }
        ]
      case 'energy-rate':
        return [
          {
            id: 1,
            text: ctx.app.i18n.t('singleRate'),
            icon: 'tariff'
          },
          {
            id: 2,
            text: ctx.app.i18n.t('nightAndDay'),
            icon: 'tariff-dn'
          }
        ]
      case 'renovation':
        return [
          {
            id: 1,
            text: ctx.app.i18n.t('newBuild'),
            icon: 'newbuild',
            _renovation: false
          },
          {
            id: 2,
            text: ctx.app.i18n.t('renovated'),
            icon: 'renovated',
            _renovation: true
          }
        ]
      case 'house-type':
        return [
          {
            id: 'DETACHED',
            text: ctx.app.$houseType('DETACHED'),
            icon: 'detached-house'
          },
          {
            id: 'SEMI_DETACHED',
            text: ctx.app.$houseType('SEMI_DETACHED'),
            icon: 'semi-detached-house'
          },
          {
            id: 'MID_TERRACE',
            text: ctx.app.$houseType('MID_TERRACE'),
            icon: 'mid-detached-house'
          }
        ]
      default:
    }
  })

  inject('houseType', (type) => {
    if (!type) return null
    switch (type) {
      case 'DETACHED':
        return ctx.app.i18n.t('detached')
      case 'SEMI_DETACHED':
        return ctx.app.i18n.t('semi-detached')
      case 'MID_TERRACE':
        return ctx.app.i18n.t('mid-detached')
      default:
    }
  })

  inject('insulationStatus', (status) => {
    if (!status) return null
    switch (status) {
      case 'POOR':
        return ctx.app.i18n.t('notInsulated')
      case 'PARTIAL':
        return ctx.app.i18n.t('slightlyInsulated')
      case 'GOOD':
        return ctx.app.i18n.t('wellInsulated')
      case 'VERY_GOOD':
        return ctx.app.i18n.t('veryWellInsulated')
      default:
    }
  })

  inject('insulationStatusList', () => {
    return [
      { id: 'POOR', text: ctx.app.$insulationStatus('POOR') },
      { id: 'PARTIAL', text: ctx.app.$insulationStatus('PARTIAL') },
      { id: 'GOOD', text: ctx.app.$insulationStatus('GOOD') },
      { id: 'VERY_GOOD', text: ctx.app.$insulationStatus('VERY_GOOD') }
    ]
  })

  inject('heatLoadCalculationOverview', (data) => {
    if (!data) return []
    return [
      {
        text: [
          ctx.app.i18n.t('houseTypeQuestion'),
          ctx.$houseType(data['house-type'])
        ]
      },
      {
        text: [
          ctx.app.i18n.t('insulationStatus'),
          ctx.$insulationStatus(data['insulation-status'])
        ]
      },
      {
        text: [
          ctx.app.i18n.t('heatSurfaceArea'),
          ctx.app.i18n.t('m2', [data['heated-surface']])
        ]
      },
      {
        text: [
          ctx.app.i18n.t('peopleLivingInHouse'),
          ctx.$peopleInHouse(data.adults, data.children)
        ]
      }
    ]
  })

  inject('peopleInHouse', (adults, children) => {
    if (adults === null && children === null) return null
    return `${ctx.app.i18n.tc('amountAdults', adults, {
      count: adults
    })}, ${ctx.app.i18n.tc('amountChildren', children, {
      count: children
    })}`
  })
}
